import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Angulartics2OnModule } from 'angulartics2';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { AlertComponent } from '@app/shared/components/alert/alert.component';

@Component({
  selector: 'app-signup-confirmation',
  templateUrl: './signup-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TopNavbarComponent,
    LoyaltyClubHeaderComponent,
    TranslatePipe,
    Angulartics2OnModule,
    RouterLink,
    LoyaltyClubFooterComponent,
    AlertComponent,
  ],
})
export class SignupConfirmationComponent implements OnInit {

  public queryParams: any = {};

  constructor(private route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.route.queryParamMap.subscribe((paramsMap) => {
      paramsMap.keys.forEach((key) => this.queryParams[key] = paramsMap.get(key));
    });
  }
}
